// @flow

import * as React from 'react';
import styled from 'styled-components';

import typeof TTheme from '../theme';

type TP = { theme: TTheme };

type Props = {|
  header: React.Node,
  subheader: React.Node,
  children?: React.Node,
|};

const Container = styled.header`
  background: ${({ theme }: TP) => theme.colors.white};
  box-shadow: inset 0 -1px 0 0 ${({ theme }: TP) => theme.colors.silver};
  display: flex;
  justify-content: space-between;
  padding-bottom: ${({ theme }: TP) =>
    parseInt(theme.spacing.standard, 10) * 1.65}px;
  padding-left: ${({ theme }: TP) => theme.spacing.standard};
  padding-right: ${({ theme }: TP) => theme.spacing.standard};
  padding-top: ${({ theme }: TP) =>
    parseInt(theme.spacing.standard, 10) * 1.65}px;
`;

const Heading = styled.h1`
  color: ${({ theme }: TP) => theme.colors.dark};
  font-size: ${({ theme }: TP) => theme.typography.size.title};
  font-weight: bold;
  line-height: 1;
  margin: 0;
  padding: 0;
`;

const Subheading = styled.div`
  color: ${({ theme }: TP) => theme.colors.blueyGrey};
  font-size: ${({ theme }: TP) => theme.typography.size.large};
  font-weight: normal;
`;

const Header = (props: Props) => (
  <Container>
    <div>
      <Heading>{props.header}</Heading>
      <Subheading>{props.subheader}</Subheading>
    </div>
    {props.children}
  </Container>
);

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js